"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Abstraction to generate formatted URLs when working with the Integration.
 * This component is written as a singleton to ensure only one ever exists in memory.
 * @param {string} environment - An object containing the required information to interact with the correct integration instance.
 * @param {string} customerId - An object containing the required information to interact with the correct integration instance.
 * @param {string} domain - An object containing the required information to interact with the correct integration instance.
 * @param {string} hmac - An object containing the required information to interact with the correct integration instance.
 * @returns {string|object}
 */
var IntegrationAPI = /*#__PURE__*/function () {
  function IntegrationAPI(_ref) {
    var _ref$environment = _ref.environment,
        environment = _ref$environment === void 0 ? '' : _ref$environment,
        _ref$customerId = _ref.customerId,
        customerId = _ref$customerId === void 0 ? '' : _ref$customerId,
        _ref$domain = _ref.domain,
        domain = _ref$domain === void 0 ? '' : _ref$domain,
        _ref$hmac = _ref.hmac,
        hmac = _ref$hmac === void 0 ? '' : _ref$hmac;

    _classCallCheck(this, IntegrationAPI);

    if (!!IntegrationAPI.instance) {
      return IntegrationAPI.instance;
    }

    IntegrationAPI.instance = this;
    this.options = {
      path: "api/customer/v2",
      environment: environment,
      customerId: customerId,
      domain: domain,
      hmac: hmac
    };
  }

  _createClass(IntegrationAPI, [{
    key: "_rootDomain",
    value: function _rootDomain() {
      return "//".concat(this.options.environment, ".shopifycloud.com");
    }
  }, {
    key: "_baseURL",
    value: function _baseURL() {
      var _this$options = this.options,
          path = _this$options.path,
          customerId = _this$options.customerId;
      return "".concat(this._rootDomain(), "/").concat(path, "/").concat(customerId);
    }
  }, {
    key: "authPayload",
    value: function authPayload() {
      return {
        domain: this.options.domain,
        hmac: this.options.hmac
      };
    } // NOTE: Customer Licence resources

  }, {
    key: "getLicences",
    value: function getLicences() {
      return "".concat(this._baseURL(), "/licences");
    } // NOTE: Licence Order History resource

  }, {
    key: "getOrder",
    value: function getOrder(orderId) {
      return "".concat(this._baseURL(), "/order/").concat(orderId);
    }
  }, {
    key: "getOrders",
    value: function getOrders() {
      return "".concat(this._baseURL(), "/orders");
    }
  }, {
    key: "postHeartbeat",
    value: function postHeartbeat() {
      return "".concat(this._baseURL(), "/heartbeat");
    } // NOTE: Used to set a licence

  }, {
    key: "postLicence",
    value: function postLicence() {
      return "".concat(this._baseURL(), "/licence");
    } // NOTE: Order Validation resources

  }, {
    key: "postValidate",
    value: function postValidate() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cart';
      return "".concat(this._baseURL(), "/orderlimit/").concat(type, "/validate");
    }
  }]);

  return IntegrationAPI;
}();

exports["default"] = IntegrationAPI;